import React, { FC } from "react";

import { LoadingSpinner } from "./LoadingSpinner";

import style from "./LoadingSection.module.scss";

export const LoadingSection: FC = () => (
  <section className={style.section}>
    <LoadingSpinner className={style.spinner} />
  </section>
);
